<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-6">
            <a @click="openPage('/sales')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
            <a class="btn-secondary text-center" v-b-modal="'modalChangePass'"><i class="fas fa-cog mr-5"></i>Change Password</a>
            <b-modal modal-class="modal-custom-image" hide-footer centered id="modalChangePass">
              <div class="p-10">
                <form @submit.prevent="validateChangePass('changePassForm')" data-vv-scope="changePassForm">
                  <div class="mb-10">
                    <input type="password" v-model="changePassData.old_password" placeholder="Current Password" class="w-100" v-validate="'required'" name="current_password">
                    <span class="error">{{ errors.first('changePassForm.current_password') }}</span>
                  </div>
                  <div class="mb-10">
                    <input ref="pw_confirm" v-model="changePassData.new_password" type="password" placeholder="New Password" class="w-100" v-validate="'required'" name="new_password">
                    <span class="error">{{ errors.first('changePassForm.new_password') }}</span>
                  </div>
                  <div class="mb-10">
                    <input type="password" v-model="changePassData.confirm_password" placeholder="Confirm New Password" class="w-100" v-validate="'required|confirmed:pw_confirm'" name="confirm_new_password">
                    <span class="error">{{ errors.first('changePassForm.confirm_new_password') }}</span>
                  </div>
                  <div class="text-right">
                    <button type="submit" class="btn-primary">Save</button>
                  </div>
                </form>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="salesName" v-model="editData.fullname" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input class="bg-transparent" disabled v-model="editData.email" name="email" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Phone Number</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.phone_number" name="phone_number" v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('phone_number') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20 hidden">
                <b-col sm="2">
                  <label>Privy ID</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.privy_id" name="privy_id" type="text"></b-form-input>
                  <span class="error">{{ errors.first('privy_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>ID Card</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.id_card" name="id_card" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Keysoft ID</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.keysoft_salesman_id" name="keysoft_salesman_id" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="editData.branch_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_pt">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" @change="previewImage" accept="image/*" v-model="editData.photos" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Address</label>
                </b-col>
                <b-col sm="10">
                  <textarea id="address" name="address" class="w-100" rows="3" v-model="editData.address"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Resign</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="staff_status" v-model="editData.is_resign">
                    <option :value="null">Please select</option>
                    <option :value="1">Yes</option>
                    <option :value="0">No</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('staff_status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="editData.is_resign == 1">
                <b-col sm="2">
                  <label>Resign Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="config" v-model="editData.resign_date" name="resign_date" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('resign_date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.status" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Show to Report</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="is_show_to_report" v-validate="'required'" v-model="editData.is_show_to_report" :options="options_show_to_report" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('is_show_to_report') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import editVue from '../allForm/edit.vue'

export default {
  name: 'editCoach',
  data: function () {
    return {
      editData: {
        fullname: '',
        email: '',
        address: '',
        phone_number: '',
        privy_id: '',
        id_card: '',
        user_role: '',
        photos: '',
        branch_id: '',
        keysoft_salesman_id: '',
        resign_date: null,
        is_resign: null,
        status: null,
        is_show_to_report: null
      },
      config: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d'
      },
      changePassData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      dataBranch: [],
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      options_show_to_report: [
        { value: null, text: 'Please select' },
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()

          data.append('fullname', this.editData.fullname)
          data.append('email', this.editData.email)
          data.append('address', this.editData.address)
          data.append('phone_number', this.editData.phone_number)
          data.append('privy_id', this.editData.privy_id)
          data.append('id_card', this.editData.id_card)
          data.append('keysoft_salesman_id', this.editData.keysoft_salesman_id)
          data.append('user_role', this.editData.user_role)
          data.append('photos', this.editData.photos)
          data.append('branch_id', this.editData.branch_id)
          data.append('is_resign', this.editData.is_resign)
          data.append('status', this.editData.status)
          data.append('resign_date', this.editData.resign_date)
          data.append('is_show_to_report', this.editData.is_show_to_report)

          axios.put('crm/v1/sales/' + this.$route.query.id, data).then(response => {
            this.$router.push('/sales')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    validateChangePass (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          axios.put('crm/v1/sales/change_password/' + this.$route.query.id, this.changePassData).then(response => {
            // console.log('test', response)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/sales')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/sales/'+ this.$route.query.id).then(response => {
        this.editData = response.data.data
        this.editData.fullname = response.data.data.fullname
        this.editData.email = response.data.data.email
        this.editData.address = response.data.data.address
        this.editData.phone_number = response.data.data.phone_number
        this.editData.id_card = response.data.data.id_card
        this.editData.keysoft_salesman_id = response.data.data.keysoft_salesman_id
        this.editData.user_role = response.data.data.user_role.name
        this.editData.photos = response.data.data.thumbnail
        this.editData.branch_id = response.data.data.branch.id
        this.editData.status = response.data.data.status
        this.editData.is_show_to_report = response.data.data.is_show_to_report
        this.imageData = Auth.apiUrl + 'crm/v1/img/sales/' + response.data.data.thumbnail
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
